<template>
  <v-dialog v-model="show" scrollable max-width="400px">
        <v-card>
          <v-card-title>Add Contact</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 300px;">
            <v-form ref="newContact" v-model="newContactFormValid">
            <v-form-base
                v-bind:value="newContactData"
                v-bind:schema="contactSchema"
              />
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="secondary darken-1" outlined @click="hideDialog">Close</v-btn>
            <v-btn
              color="primary darken-1"
              @click="addContact(newContactData); hideDialog()"
            >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
</template>
<script>
import apiService from '@/services'
import formRules from '@/mixins'
import VFormBase from 'vuetify-form-base'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    entityType: {
      type: String
    },
    entityId: {
      type: Number
    }
  },
  components: {
    VFormBase
  },
  mixins: [formRules],
  computed: {
    contactSchema () {
      return {
        first_name: {
          type: 'text',
          label: 'First name *',
          flex: 6,
          rules: [this.validationRules.requiredField('First name')]
        },
        last_name: {
          type: 'text',
          label: 'Last name *',
          flex: 6,
          rules: [this.validationRules.requiredField('Last name')]
        },
        email: {
          type: 'text',
          label: 'Email *',
          flex: 12,
          rules: [
            this.validationRules.requiredField('Email')
          ]
        },
        phone: {
          type: 'text',
          label: 'Phone',
          flex: 12
        },
        role: {
          mandatory: true,
          type: 'radio',
          row: false,
          options: [
            { value: 'is_legal_rep', label: 'Is legal representative' },
            { value: 'is_tech_rep', label: 'Is tecnical contact' }
          ]
        }
      }
    }

  },
  data () {
    return {
      newContactFormValid: true,
      newContactData: {
        first_name: ''
      },
      contactDialog: false
    }
  },
  methods: {
    addContact (data) {
      data[data.role] = true
      apiService
        .createContact(this.entityType, this.entityId, data)
        .then()
        .catch(error => {
          if (error.status === 409) {
            this.$store.dispatch('alert/showSnackbar', {
              color: 'error',
              text: `Error: ${error.response.data.detail}`
            })
          } else {
            this.$store.dispatch('alert/showSnackbar', {
              color: 'error',
              text: `Error: ${error.response.data.detail}`
            })
          }
        })
    },
    hideDialog () {
      this.$emit('hide-dialog')
    }
  }
}
</script>
